import { mapGeoResponse } from "~/utility/location/location.mapper";
import { LocationService } from "../location.service";

export const setLocationByAddressHandler = async (address: string) => {

    if (!address) {
        return { success: false, message: "Address is required" };
    }

    try {

        const { data, error: apiError } =
            await LocationService.geocode(address);

        if (apiError) {
            return { success: false, message: apiError };
        }

        if (!data?.length) {
            return { success: false, message: "No address found." };
        }

        const location = data[0];

        if (!location) {
            return {
                success: false,
                message: "No address found for the selected location.",
            };
        }

        const cityName = location?.city?.trim();

        if (!cityName) {
            return {
                success: false,
                message: "City not available for this location.",
            };
        }

        // 2. Fetch City Code
        const { data: cityData, error: cityError } =
            await LocationService.searchCities(cityName);

        if (cityError) {
            console.warn("City API failed:", cityError);
        }

        let cityCode = null;

        if (cityData?.length) {
            cityCode = cityData[0]?.code ?? null;
        } else {
            console.warn("No matching city found");
        }

        // ✅ Always continue
        const enrichedLocation = {
            ...location,
            city: {
                name: cityName || location?.city?.name || null,
                code: cityCode,
            },
        };

        // 3. Map
        const mapped = await mapGeoResponse(enrichedLocation, 'FROM_ADDRESS');

        return {
            success: true,
            message: "Location updated successfully.",
            data: mapped,
        };
    } catch (error) {
        console.error("setLocationByAddressHandler", error);
        return { success: false, message: "Failed to set location by address", error: error };
    }

}